<template>
<div class="center-warp">
  <div class="inner d-flex-between">
    <div class="left-menu">
      <div :class="menuIndex == 0 ? 'on':''" @click="menuChange(0)">基本资料</div>
      <div :class="menuIndex == 1 ? 'on':''" @click="menuChange(1)">图片资料</div>
      <div v-if="showMoreData" :class="menuIndex == 2 ? 'on':''" @click="menuChange(2)">补充资料</div>
    </div>
    <div class="right-cont" @scroll="handScroll" ref="contRef">
      <div ref="part1" class="add-item">
        <div class="add-data-title">基本资料</div>
        <div class="d-flex-between">
          <div class="add-data-item">
            <div>姓名</div>
            <div  class="add-data-item-input"><input type="text" v-model="caseOption.name" placeholder="填写姓名"></div>
          </div>
          <div class="add-data-item">
            <div>出生日期</div>
            <el-date-picker
                v-model="caseOption.birthday"
                format="yyyy.MM.dd"
                value-format="yyyy.MM.dd"
                type="date"
                prefix-icon="el-icon-arrow-right"
                clear-icon="none"
                class="add-data-item-input"
                @change="bornDateChange"
                :picker-options="pickerBornOption"
                placeholder="选择出生日期">
            </el-date-picker>
          </div>
          <div class="add-data-item">
            <div>期望套餐类型</div>
            <el-dropdown @command="handelPackageChange" trigger="click">
              <div class="add-data-item-input"><input type="text" :value="packageType.name" placeholder="选择套餐类型"><i class="iconfont icon-youjiantou"></i></div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item" v-for="item in packageList">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="add-data-item">
            <div>首诊日期</div>
            <el-date-picker
                v-model="caseOption.card_date"
                format="yyyy.MM.dd"
                value-format="yyyy.MM.dd"
                type="date"
                prefix-icon="el-icon-arrow-right"
                clear-icon="none"
                class="add-data-item-input"
                @change="firstDateChange"
                :picker-options="pickerBornOption"
                placeholder="选择首诊日期">
            </el-date-picker>
          </div>
        </div>
        <div class="add-data-item">
          <div>病例主诉</div>
          <textarea v-model="caseOption.case_info" class="case-main-info" placeholder="填写病例主要诉求…"></textarea>
        </div>
      </div>
      <div ref="part2" class="add-item" >
        <div class="add-data-title">图片资料 <span>请上传图片资料</span></div>
        <div class="upload-img-warp">
          <div class="upload-img-line">
            <div class="upload-img-item uploadItem3-l">
            <template v-if="caseOption.cemian_pic == ''">
              <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                :action="'cemian_pic'">
                <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg1.png" alt="">
                <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
              </el-upload>
              <div class="upload-img-item-name" >侧面照</div>
            </template>
            <template v-else>
              <img @click="editCaseImg('cemian_pic')" class="upload-img-item-val" :src="caseOption.cemian_pic" alt="">
              <img @click="delCaseImg('cemian_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
            </template>
            </div>
            <div class="upload-img-item uploadItem3-l">
              <template v-if="caseOption.zhengmian_pic == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'zhengmian_pic'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg1.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >正面照</div>
              </template>
              <template v-else>
                <img @click="editCaseImg('zhengmian_pic')" class="upload-img-item-val" :src="caseOption.zhengmian_pic" alt="">
                <img @click="delCaseImg('zhengmian_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
            <div class="upload-img-item uploadItem3-l">
              <template v-if="caseOption.zhengmian_weixiao_pic == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'zhengmian_weixiao_pic'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg1.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >正面微笑照</div>
              </template>
              <template v-else>
                <img @click="editCaseImg('zhengmian_weixiao_pic')" class="upload-img-item-val" :src="caseOption.zhengmian_weixiao_pic" alt="">
                <img @click="delCaseImg('zhengmian_weixiao_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
          </div>
          <div class="upload-img-line">
            <div class="upload-img-item uploadItem3-s">
              <template v-if="caseOption.youce_yaohe_pic == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'youce_yaohe_pic'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >右侧位咬合照</div>
              </template>
              <template v-else>
                <img @click="editCaseImg('youce_yaohe_pic')" class="upload-img-item-val" :src="caseOption.youce_yaohe_pic" alt="">
                <img @click="delCaseImg('youce_yaohe_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
            <div class="upload-img-item uploadItem3-s">
              <template v-if="caseOption.zhengwei_yaohe_pic == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'zhengwei_yaohe_pic'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >正位咬合照</div>
              </template>
              <template v-else>
                <img @click="editCaseImg('zhengwei_yaohe_pic')" class="upload-img-item-val" :src="caseOption.zhengwei_yaohe_pic" alt="">
                <img @click="delCaseImg('zhengwei_yaohe_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
            <div class="upload-img-item uploadItem3-s">
              <template v-if="caseOption.zuoce_yaohe_pic == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'zuoce_yaohe_pic'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >左侧咬合照</div>
              </template>
              <template v-else>
                <img @click="editCaseImg('zuoce_yaohe_pic')" class="upload-img-item-val" :src="caseOption.zuoce_yaohe_pic" alt="">
                <img @click="delCaseImg('zuoce_yaohe_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
          </div>
          <div class="upload-img-line">
            <div class="upload-img-item uploadItem1">
              <template v-if="caseOption.quanjing_pic == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'quanjing_pic'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg3.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >全景照</div>
              </template>
              <template v-else>
                <img @click="editCaseImg('quanjing_pic')" class="upload-img-item-val" :src="caseOption.quanjing_pic" alt="">
                <img @click="delCaseImg('quanjing_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
          </div>
          <div class="upload-img-line">
            <div class="upload-img-item uploadItem2">
              <template v-if="caseOption.ceweimian_x_pic == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'ceweimian_x_pic'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg4.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >侧位片(X光)</div>
              </template>
              <template v-else>
                <img @click="editCaseImg('ceweimian_x_pic')" class="upload-img-item-val" :src="caseOption.ceweimian_x_pic" alt="">
                <img @click="delCaseImg('ceweimian_x_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
            <div>
              <div class="upload-img-line">
                <div class="upload-img-item uploadItem3-s">
                  <template v-if="caseOption.shanglingyalie_pic == ''">
                    <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                               :action="'shanglingyalie_pic'">
                      <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                      <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                    </el-upload>
                    <div class="upload-img-item-name" >上颌牙列照</div>
                  </template>
                  <template v-else>
                    <img @click="editCaseImg('shanglingyalie_pic')" class="upload-img-item-val" :src="caseOption.shanglingyalie_pic" alt="">
                    <img @click="delCaseImg('shanglingyalie_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                  </template>
                </div>
              </div>
              <div class="upload-img-line" style="margin-bottom: 0">
                <div class="upload-img-item uploadItem3-s">
                  <template v-if="caseOption.xialingyalie_pic == ''">
                    <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                               :action="'xialingyalie_pic'">
                      <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                      <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                    </el-upload>
                    <div class="upload-img-item-name" >下颌牙列照</div>
                  </template>
                  <template v-else>
                    <img @click="editCaseImg('xialingyalie_pic')" class="upload-img-item-val" :src="caseOption.xialingyalie_pic" alt="">
                    <img @click="delCaseImg('xialingyalie_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="upload-img-line">
            <div class="upload-img-item uploadItem3-m">
              <template v-if="caseOption.fuhe_fugai_pic == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'fuhe_fugai_pic'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >覆合覆盖照 <span>（选填）</span></div>
              </template>
              <template v-else>
                <img @click="editCaseImg('fuhe_fugai_pic')" class="upload-img-item-val" :src="caseOption.fuhe_fugai_pic" alt="">
                <img @click="delCaseImg('fuhe_fugai_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
            <div class="upload-img-item uploadItem3-m">
              <template v-if="caseOption.zhengmian_kaikou_zhao == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'zhengmian_kaikou_zhao'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >正面开口照 <span>（选填）</span></div>
              </template>
              <template v-else>
                <img @click="editCaseImg('zhengmian_kaikou_zhao')" class="upload-img-item-val" :src="caseOption.zhengmian_kaikou_zhao" alt="">
                <img @click="delCaseImg('zhengmian_kaikou_zhao')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
            <div class="upload-img-item uploadItem3-m">
              <template v-if="caseOption.zhengmian_yangshi_pic == ''">
                <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                           :action="'zhengmian_yangshi_pic'">
                  <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                  <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                </el-upload>
                <div class="upload-img-item-name" >正面仰视照 <span>（选填）</span></div>
                <div class="upload-img-item-tips">注: 反合病例替换为正面切对切咬合照</div>
              </template>
              <template v-else>
                <img @click="editCaseImg('zhengmian_yangshi_pic')" class="upload-img-item-val" :src="caseOption.zhengmian_yangshi_pic" alt="">
                <img @click="delCaseImg('zhengmian_yangshi_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
              </template>
            </div>
          </div>
        </div>
      </div>
      <div ref="part3" class="add-item" v-if="showMoreData">
        <div class="add-data-title" >补充视频资料</div>
        <div class="case-upload-line">
          <div  class="upload-video-item" v-for="i in 2">
            <video controls src="../../assets/img/case_management/test.mp4"></video>
            <div>MP4</div>
            <img class="upload-img-item-del" src="../../assets/img/case_management/del2.png" alt="">
          </div>
          <div class="upload-video">
            <img class="upload-video-bg" src="../../assets/img/case_management/upload-video-bg.png" alt="">
            <img class="upload-video-icon" src="../../assets/img/case_management/upload-video-icon.png" alt="">
            <div class="black-14">上传视频</div>
          </div>
        </div>
      </div>
      <div class="annotate-btn">
        <div @click="goBack">取消</div>
        <div @click="saveAddCase">保存</div>
      </div>
    </div>
    <el-dialog
        :close-on-click-modal="false"
        :visible.sync="showImgEditor"
        custom-class="take-dialog"
        title="图片编辑"
        width="1080px">
      <div class="img-editor-warp">
        <div style="width: 1040px;height: 760px;">
          <EditImg ref="editImg" :key="caseOption[editImgName]" :bgUrl="caseOption[editImgName]" />
        </div>
        <div class="d-flex" style="justify-content: flex-end">
          <div class="img-editor-right-btn">
            <div @click="showImgEditor = false">取消</div>
            <div @click="editImgOK">确定</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</div>
</template>

<script>
import EditImg from '@/components/EditImg'
import {CreateCase, GetListByTypeCode} from "@/http/api";
import ossUpload from "@/http/ossUpload";
export default {
  name: "add_case",
  components:{EditImg},
  data() {
    return {
      menuIndex: 0,
      menuOffsetTop:[],
      packageList:[],
      packageType:{},
      showImgEditor:false,
      cutImgUrl:require('../../assets/img/case_management/test-upload-img.png'),
      caseOption:{
        birthday: '', //出生日期
        card_date: '', //卡日期
        case_info: '',//首诊主诉
        cemian_pic: '',//侧面照
        ceweimian_x_pic: '',//侧位面x照
        first_case_type: '',//期望套餐类型，4：快乐+,5：散件,6：全周期（含耗材）7：双期第一期（含耗材）8：双期第二期（含耗材）注意：如果不传这个值，默认就为散件
        fuhe_fugai_pic: '',//覆合覆盖照
        name: '',//患者姓名
        other_media_json: {},//其他图文或者视频资料
        quanjing_pic: '',//全景片
        shanglingyalie_pic: '', //上领牙列照
        xialingyalie_pic: '', //下领牙列照
        youce_yaohe_pic: '', //右侧位咬合照
        zhengmian_kaikou_zhao: '',//正面开口照
        zhengmian_pic: '', //正面照
        zhengmian_weixiao_pic: '', //正面微笑照
        zhengmian_yangshi_pic: '', //正面仰视照
        zhengwei_yaohe_pic: '', //正位咬合照
        zuoce_yaohe_pic: '',  //左侧位咬合照
      },
      editImgName:'',
      showMoreData:false,
      pickerBornOption:{
        disabledDate(time){
          return time.getTime() > new Date().getTime()
        }
      }
    }
  },
  mounted() {
    this.$store.commit('breadChange',{name:'创建病例',isBack:true})
    this.caseOption.card_date = new Date().toLocaleDateString().replaceAll('/','.')
    this.$nextTick(()=>{
      this.menuOffsetTop[0] = this.$refs.part1.offsetTop
      this.menuOffsetTop[1] = this.$refs.part2.offsetTop
      if(this.showMoreData) this.menuOffsetTop[2] = this.$refs.part3.offsetTop
      else this.menuOffsetTop[2] = 9999
    })
    GetListByTypeCode({type_code:['app_patient_first_case_type']}).then(res=>{
      this.packageList = res.data.app_patient_first_case_type
    })
  },
  methods:{
    handScroll(e){
      if(e.target.scrollTop < this.menuOffsetTop[1] - 10){
        this.menuIndex = 0
      }else if(e.target.scrollTop >= this.menuOffsetTop[1] - 20 && e.target.scrollTop <  this.menuOffsetTop[2] - 20){
        this.menuIndex = 1
      }else this.menuIndex = 2

    },
    menuChange(i) {
      this.menuIndex = i
      this.$refs.contRef.scrollTo({
        top:this.menuOffsetTop[i],
        behavior:'smooth'
      })
    },
    bornDateChange(val){
     this.caseOption.birthday = val
    },
    firstDateChange(val){
     this.caseOption.card_date = val
    },
    handelPackageChange(val){
      this.packageType = val
    },
    realTime(data){
      // console.log(data)
    },
    imgRotate(type){
      if(type == 'left'){
        this.$refs.cropper.rotateLeft()
      }else{
        this.$refs.cropper.rotateRight()
      }
    },
    editImgOK(){
      let blobUrl = this.$refs.editImg.saveImg()
      this.uploadImg(blobUrl)
      this.showImgEditor = false
    },
    uploadImg(file){
      ossUpload.bucketUpload(file,(res)=>{
        this.caseOption[this.editImgName] = res.url
        console.log(this.caseOption)
      },(err)=>{
        this.$message({
          type:"error",
          message:'上传失败'
        })
      },'duole-images','/upload/image/pc/create_case/')
    },
    uploadImgPre(e){
      this.handleImgChange(e.file,e.action)
    },
    handleImgChange(file,name) {
      ossUpload.bucketUpload(file,(res)=>{
        this.caseOption[name] = res.url
        console.log(this.caseOption)
      },(err)=>{
        this.$message({
          type:"error",
          message:'上传失败'
        })
      },'duole-images','/upload/image/pc/create_case/')
    },
    // handleImgChange(e,name) {
    //   ossUpload.bucketUpload(e.target.files[0],(res)=>{
    //     this.caseOption[name] = res.url
    //     console.log(this.caseOption)
    //   },(err)=>{
    //     this.$message({
    //       type:"error",
    //       message:'上传失败'
    //     })
    //   },'duole-images','image')
    // },
    delCaseImg(name){
      this.caseOption[name] = ''
    },
    editCaseImg(name){
      this.editImgName = name
      this.showImgEditor = true
    },
    goBack(){
      this.$router.push('/case_management')
    },
    saveAddCase(){
      if(!this.$store.state.workState) return false

      this.caseOption.first_case_type = this.packageType.item_value

      let wrongTxt = ''
      if(this.caseOption.name.trim() == '') wrongTxt = '姓名不能为空'
      else if(this.caseOption.birthday == '') wrongTxt = '出生日期不能为空'
      else if(this.caseOption.case_info == '') wrongTxt = '病例主诉不能为空'
      else if(this.caseOption.cemian_pic == '') wrongTxt = '请上传侧面照'
      else if(this.caseOption.zhengmian_pic == '') wrongTxt = '请上传正面照'
      else if(this.caseOption.zhengmian_weixiao_pic == '') wrongTxt = '请上传正面微笑照'
      else if(this.caseOption.youce_yaohe_pic == '') wrongTxt = '请上传右侧位咬合照'
      else if(this.caseOption.zhengwei_yaohe_pic == '') wrongTxt = '请上传正位咬合照'
      else if(this.caseOption.zuoce_yaohe_pic == '') wrongTxt = '请上传左侧咬合照'
      else if(this.caseOption.quanjing_pic == '') wrongTxt = '请上传全景照'
      else if(this.caseOption.ceweimian_x_pic == '') wrongTxt = '请上传侧位片（x光）'
      else if(this.caseOption.shanglingyalie_pic == '') wrongTxt = '请上传上颌牙列照'
      else if(this.caseOption.xialingyalie_pic == '') wrongTxt = '请上传下颌牙列照'
      if(wrongTxt != ''){
        this.$refs.contRef.scrollTo({
          top:this.menuOffsetTop[0],
          behavior:'smooth'
        })
        this.$message({
          type:'error',
          message:wrongTxt
        })
        return false
      }
      this.$store.commit('workStart')
      CreateCase(this.caseOption).then(res=>{
        if(res.code == 200){
          this.$message({
            type:'success',
            message:'保存成功'
          })
          this.$router.push('/case_management?id=' + res.data.patientModel.id + '&new=1')
        }else{
          this.$message({
            type:'error',
            message:res.message[0]
          })
        }
        this.$store.commit('workOver')
      })
    }
  }
}
</script>

<style scoped src="../../assets/css/case_management_add_case.css">
</style>
<style>
.add-data-item-input {
  position: relative;
}
.add-data-item-input input{
  width: 176px;
  height: 34px;
  background: #F4F4F4;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 14px;
  border: none;
  padding-left: 10px !important;
}
.add-data-item-input .el-input__prefix{
  left: 150px;
  top: -2px;
}
.add-data-item-input .el-icon-arrow-right{
  color: #B1B1B1;
  font-size: 12px;
  font-weight: bold;
}
.add-data-item-input .icon-youjiantou{
  position: absolute;
  right: 10px;
  color: #B1B1B1;
  font-size: 10px;
  top: 8px;
  font-weight: bold;
}
.add-data-item-input input::placeholder{
  color: rgba(60,60,67,0.3);
}
.add-data-item-input input:focus{
  background: rgba(254,212,0,0.05);
  border: 1px solid #FED400;
}
/*上传图片样式*/
.upload-img-item .el-upload-dragger{
  width: fit-content;
  height: 100%;
  border: none;
  display: flex;
}
</style>

